export default class Store_Storage {
  state = null;
  // read only
  defaultState = {
    timerRemaining: {
      // {$blockId}: int in seconds
    },
  };

  constructor(prefixId) {
    this.id = prefixId;
  }

  getLocalStorage() {
    // we need to mock localStorage because sometimes there is user that block third-party cookies
    const inIframe = () => {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    };

    if (inIframe()) {
      return {
        getItem: () => {
          return null;
        },
        setItem: () => {},
        removeItem: () => {},
      };
    } else {
      return window.localStorage;
    }
  }

  load() {
    const state = this.getLocalStorage().getItem("bd-" + this.id);
    this.state = state ? JSON.parse(state) : this.defaultState;
  }

  save(key, value) {
    this.state[key] = value;
    this.getLocalStorage().setItem("bd-" + this.id, JSON.stringify(this.state));
  }

  delete() {
    this.getLocalStorage().removeItem("bd-" + this.id);
  }
}
